import Button from 'components/Button'
import { MobileView } from 'components/DeviceDetect'
import { WoundedArrow } from 'components/Icons'
import WhiteWarning from 'components/Icons/Warning/WhiteWarning'
import Input from 'components/Input'
import Loader from 'components/Loader'
import OrderSuccessConfirmationModal from 'components/Order/OrderSuccessConfirmationModal'
import Message from 'components/UI/Message'
import Warning from 'components/Widgets/Warning'
import React, { useState } from 'react'
import { useHistory } from 'react-router'
import {
  onLandingSentConversion,
  onProductAddToCartEvent,
} from 'services/conversionevents'
import OrdersService from 'services/OrdersService'
import useAuth from 'store/AuthContext'
import useCart from 'store/CartProvider'
import useOrders from 'store/OrdersProvider'
import useProduct from 'store/SingleProductProvider'
import LandingProductHead from './LandingProductHead'
import LandingProductLeftSide, {
  CProductConditions,
} from './LandingProductLeftSide'
import {
  Hint,
  InfoContent,
  LabelWithInput,
  ProductContainer,
  ProductContent,
  ProductForm,
  ProductInfo,
} from './Product.style'
import { appendTrackingParamsToFormData } from 'consts'

const Product = props => {
  const {
    product,
    product: { landing },
  } = useProduct()
  const { user, userAuthenticated } = useAuth()
  const history = useHistory()
  const [success, setSuccess] = useState(false)
  const [confirmModal, setConfirmModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState({})
  const [requestError, setRequestError] = useState(false)
  const { setSuccessMessage } = useOrders()

  const orderFormSubmitted = e => {
    e.preventDefault()
    const formData = new FormData(e.target)
    setLoading(true)
    setRequestError(false)
    onProductAddToCartEvent(product, {
      payMethod: 'cash',
    })
    OrdersService.placeLandingOrder(formData)
      .then(data => {
        setSuccess(true)
        setLoading(false)
        setSuccessMessage('Order successfully sent')
        onLandingSentConversion(product, {
          cgd: landing.isCgd,
          order_id: data.order_id,
        })
        if (data.next_step === 'profile') {
          history.push('/account/orders')
        } else if (data.next_step === 'confirm_number') {
          setResponse(data)
          setConfirmModal(true)
        }
        /* eslint-disable-next-line */
      })
      .catch(err => {
        console.log(err)
        setRequestError(true)
        setLoading(false)
      })
  }

  const onOrderConfirm = () => {
    userAuthenticated().then(() => {
      history.push('/account/orders')
    })
  }

  return (
    <ProductContainer>
      <LandingProductHead />
      <ProductContent>
        <LandingProductLeftSide />
        <ProductInfo>
          {/* <BrowserView>
            <WaringArea>
              <Warning
                color="yellow"
                description={
                  stock_status === 1 ? 'Stock quantity:' : 'Stock quantity'
                }
                warning={stock_status === 1 ? '26 items' : 'In stock'}
              />
            </WaringArea>
          </BrowserView> */}
          <InfoContent>
            {landing.isCgd ? (
              <h3
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                {product.price}₾
                <span className="old-price">
                  {product.old_price ||
                    Math.ceil((product.price * 1.3) / 10) * 10 - 1}
                  ₾
                </span>
                {/* <WoundedArrow /> */}
              </h3>
            ) : (
              <h3
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                {product.installment_price}₾{' '}
                <span style={{ fontSize: 'smaller' }}>/Month</span>
                <span className="old-price">
                  {Math.ceil(product.installment_price * 1.2)}₾
                  <span style={{ fontSize: 'smaller' }}>/Month</span>
                </span>
                {/* <WoundedArrow /> */}
              </h3>
            )}
            <Divider />
            {loading ? (
              <div className="flex py-4">
                <Loader notFull visible={true} type="ThreeDots" />
              </div>
            ) : (
              <ProductForm onSubmit={orderFormSubmitted}>
                <input type="hidden" name="product_id" value={product.id} />
                <input
                  type="hidden"
                  name="landing_signature"
                  value={product.landing.signature}
                />
                <LabelWithInput className="name-label">
                  <span>Full Name:</span>
                  <Input
                    style={{ borderRadius: '10px', borderColor: 'green' }}
                    name="name"
                    defaultValue={user.name}
                    component="custom"
                    placeholder="Full Name"
                  />
                </LabelWithInput>
                <LabelWithInput className="phone-label">
                  <span>Phone Number:</span>
                  <Input
                    style={{ borderRadius: '10px', borderColor: 'green' }}
                    defaultValue={user.phone}
                    name="number"
                    component="custom"
                    type="number"
                    placeholder="5XX XXX XXX"
                  />
                </LabelWithInput>
                <Button
                  style={{ fontSize: '20px', fontWeight: 'bold' }}
                  color="orange"
                  disabled={success}
                >
                  Buy Now
                </Button>
              </ProductForm>
            )}
            <Message
              show={requestError}
              type="error"
              message="Error while sending order"
            />
          </InfoContent>

          <Hint>
            <p className="text-xs flex items-center gap-x-1">
              <WhiteWarning fill="#000" />I accept terms and conditions
            </p>
            <div className="flex w-100 justify-center align-center my-4">
              <WoundedArrow color="black1" width="70.32" height="53.43" />
            </div>
            <Warning
              color={'green'}
              icon="check"
              iconSize={32}
              description={
                <span
                  style={{
                    fontSize: 'larger',
                  }}
                >
                  After placing an order we will contact you ASAP
                </span>
              }
            />
          </Hint>
        </ProductInfo>
        <MobileView>
          <div className="p-4">
            <CProductConditions />
          </div>
        </MobileView>
      </ProductContent>
      <OrderSuccessConfirmationModal
        onNumberConfirm={onOrderConfirm}
        show={confirmModal}
        response={response}
      />
    </ProductContainer>
  )
}

export default Product

const Divider = () => {
  return (
    <div
      style={{
        height: '1px',
        background: 'lightgray',
        margin: '15px 0',
        width: '100%',
      }}
    />
  )
}
